import get from 'lodash/get';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { UiInnerNotSPALink } from 'src/components/UI/InnerNotSPALink';
import { brandingModelSelector, commonCurrentPartnerSelector } from 'src/store/commonPart/selector';
import { currentUserSelector } from 'src/store/user/selectors';
import { getSearchReturnUrl } from 'src/utils/url';
import { HeaderNavbarRightItems } from './NavbarItems';
import { Sidebar } from '../Sidebar';

type Props = {
  hideRallyUpLogo?: boolean;
};

export const HeaderNavbar: React.FC<Props> = ({ hideRallyUpLogo = false }) => {
  const { response: partnerModel } = useSelector(commonCurrentPartnerSelector);
  const brandingModel = useSelector(brandingModelSelector);
  const { response: userModel } = useSelector(currentUserSelector);

  const { t } = useTranslation();

  const toolbarButton = useMemo(
    () => ({
      show: get(window, 'toolbarButton.isToolbarButtonShown', false),
      returnUrl: getSearchReturnUrl() || get(window, 'toolbarButton.returnUrl', false) || '',
    }),
    []
  );

  return (
    <nav className="r-h-navbar" role="navigation">
      {toolbarButton.show && (
        <div className="toolbarbtn hidden-xs">
          <UiInnerNotSPALink className="btn btn-primary" href={toolbarButton.returnUrl}>
            {t('header.returnToSetup')}
          </UiInnerNotSPALink>
        </div>
      )}

      <Sidebar
        hideRallyUpLogo={hideRallyUpLogo}
        brandingModel={brandingModel}
        authenticated={userModel?.IsAuthenticated || false}
      />

      <HeaderNavbarRightItems partner={partnerModel} user={userModel} brandingModel={brandingModel} />
    </nav>
  );
};
